import styled from 'styled-components';

const Type = styled.div`
  font-size: 20px;
  color: #e3e2eb;
  opacity: 0.5;
`;

export default Type;
